import { PilotId } from '~/eds/src/types/PilotId';
import { User } from '~/eds/src/types/User';

export const getSelectedUsers = (
  value: PilotId | PilotId[],
  previouslySelectedUsers: Record<PilotId, User>,
  searchableUsers: Record<PilotId, User>,
): Record<PilotId, User> => {
  const updatedSelectedUsers: Record<PilotId, User> = {};
  if (Array.isArray(value)) {
    value.forEach((userId: PilotId) => {
      const selectedUser =
        previouslySelectedUsers[userId] ?? searchableUsers[userId];
      if (selectedUser) {
        updatedSelectedUsers[userId] = selectedUser;
      }
    });
  } else {
    const selectedUser =
      previouslySelectedUsers[value] ?? searchableUsers[value];
    if (selectedUser) {
      updatedSelectedUsers[value] = selectedUser;
    }
  }
  return updatedSelectedUsers;
};

export const getUsers = (
  ids: number | number[],
  users: Record<number, User>,
): Record<PilotId, User> => {
  const usersArray = Array.isArray(ids)
    ? ids.map((id) => users[id])
    : [users[ids]];
  return usersArray.reduce((acc, user) => {
    return user ? { ...acc, [user.id]: user } : acc;
  }, {});
};
